var Scenarios = (function($) {

    var _s = {
      current_step: 1,
      max_steps: 3,
      step_trigger: '.chm-block-scenarios .js-step-trigger',
      prev_step_trigger: '.chm-block-scenarios .js-prev-step-trigger',
      step_1_step_trigger: '.chm-block-scenarios .step-1-container .js-step-trigger',
      step_2_step_trigger: '.chm-block-scenarios .step-2-container .js-step-trigger',
      // step_3_step_trigger: '.chm-block-scenarios .step-3-container .js-step-trigger',
      container: '.chm-block-scenarios',
      title_container: '.chm-block-scenarios .title-container',
      step_1_step_container: '.chm-block-scenarios .step-1-container',
      step_2_step_container: '.chm-block-scenarios .step-2-container',
      step_3_step_container: '.chm-block-scenarios .step-3-container',
      scenario_id_el: '[data-scenario]',
      scenario: '.scenario',
      step_1_scenario: '.chm-block-scenarios .step-1-container .scenario',
      step_2_scenario: '.chm-block-scenarios .step-2-container .scenario',
      step_3_cta: '.chm-block-scenarios .step-3-container .scenario .cta',
    };


    
    // ### Init
    var _init = function() {
      _bindEvents();
    };

    // ### Reusable Functions
    var nextStep = function() {
      _s.current_step++;

      $(_s.container).removeClass(function (index, className) {
        return (className.match(/(^|\s)step-\S+/g) || []).join(' ');
      });

      $(_s.container).addClass('step-'+_s.current_step);
    };

    var prevStep = function() {
      _s.current_step--;

      $(_s.container).removeClass(function (index, className) {
        return (className.match(/(^|\s)step-\S+/g) || []).join(' ');
      });

      $(_s.container).addClass('step-'+_s.current_step);

      $('html, body').stop().animate({
        scrollTop: $(_s.title_container).offset().top
      }, 500);
    };

    var activateScenario = function(scenario_id) {
      $(_s.scenario_id_el).removeClass('active');
      $('[data-scenario="'+scenario_id+'"]').addClass('active');
    };

    // ### Bind Events
    var _bindEvents = function() {
      // Next Step
      $(_s.step_trigger).on('click', function() {
        if ( _s.current_step < _s.max_steps ) {
          nextStep();
        }        
      });

      // Previous Step
      $(_s.prev_step_trigger).on('click', function() {
        if ( _s.current_step > 1 ) {
          prevStep();
        }    
      });

      // Choose Scenario (Step 1)
      $(_s.step_1_step_trigger).on('click', function() {
        $(_s.scenario_id_el).removeClass('active');
        let scenario_id = $(this).parents(_s.scenario).attr('data-scenario');
        let scenario_title = $(this).parents(_s.scenario).find('.scenario-title').text().trim();
        let scenario_title_slug = scenario_title.toLowerCase().replace(/[^\w ]+/g, "").replace(/ +/g, "_"); // Slugify

        dataLayer.push({
          'tool_name': 'how_it_works',
          'engagement_type': scenario_title_slug+'_click',
          'event': 'tool_engagement'
        });

        activateScenario(scenario_id);
      });

      // Choose Scenario (Step 2)
      $(_s.step_2_scenario).on('click', function() {
        let scenario_id = $(this).attr('data-scenario');
        let scenario_title = $(this).find('.scenario-title').text().trim();
        let scenario_title_slug = scenario_title.toLowerCase().replace(/[^\w ]+/g, "").replace(/ +/g, "_"); // Slugify

        dataLayer.push({
          'tool_name': 'how_it_works',
          'engagement_type': scenario_title_slug+'_click',
          'event': 'tool_engagement'
        });

        activateScenario(scenario_id);
      });

      // Scroll to Step 3
      $(document).on('click', _s.step_2_step_trigger, function() {
        $('html, body').stop().animate({
          scrollTop: $(_s.step_3_step_container).offset().top
        },500);
      });

      // Step 3 CTA
      $(document).on('click', _s.step_3_cta, function() {
        dataLayer.push({
          'tool_name': 'how_it_works',
          'engagement_type': 'tool_complete',
          'event': 'tool_complete'
        });
      });
    };



    return {
      init: _init
    };

})(jQuery);